module.exports = __webpack_public_path__ + "static/media/Cuirass.b4606d38.jpg";